import { render, staticRenderFns } from "./MbgCitySelector.vue?vue&type=template&id=f32adb88&"
import script from "./MbgCitySelector.vue?vue&type=script&lang=js&"
export * from "./MbgCitySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports